import './App.css';
import Header        from './components/Header';
import Hero          from './components/Hero';
import TrustStrip    from './components/TrustStrip';
import Services      from './components/Services';
import Evaluations   from './components/Evaluations';
import Methods       from './components/Methods';
import Team          from './components/Team';
import Contact       from './components/Contact';
import Footer        from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <Evaluations />
        <Methods />
        <Team />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default App;
